import { MapperBase } from '../../utilities/mapper-base';
import { Upload } from '../ui/upload.model';
import { UploadBatchResource } from '../resource/upload-batch.resource';

export class UploadToUploadBatchResourceMapper extends MapperBase<Upload, UploadBatchResource> {
	map(source: Upload): UploadBatchResource {
		const dest = {} as UploadBatchResource;
		dest.uploadBatchId = source.id;
		dest.uploadBatchTypeId = source.typeId;
		dest.batchTitle = source.title;
		dest.batchComments = source.comments;
		dest.caseId = source.caseId;
		dest.userId = source.userId;
		dest.custodianId = source.custodianId;
		dest.isOcrOnServer = source.isOcrOnServer;
		dest.isUploadToAmazonS3 = source.isUploadToAmazonS3;
		dest.docSource = source.docSource;
		dest.utcOffset = source.utcOffset;
		dest.uploadBatchDate = source.uploadDate;
		dest.isCreateFolders = source.isCreateFolders;
		dest.lifeCycle = source.lifeCycle;
		return dest;
	}
}

